<div id="wait" *ngIf="isLoading == 1">
  <mat-spinner></mat-spinner>
</div>

<div class="row mt-3 score-align-row">
  <div class="col-auto">
    <p class="mtitle mb-0">Select Metric to view trends (Multi-select for making comparison)</p>
  </div>
</div>

<div class="row mt-1">
  <div class="col-md-12">
    <label class="radioOpt"><input class="square-radio" type="checkbox" id="heartrate" 
        [(ngModel)]="selectedMetrics['hr']" (change)="onMetricToggle('hr')" checked> Heart Rate</label>
    <label class="radioOpt"><input class="square-radio" type="checkbox" id="restinghr" 
        [(ngModel)]="selectedMetrics['rhr']" (change)="onMetricToggle('rhr')" checked> Resting Heart Rate</label>
    <label class="radioOpt"><input class="square-radio" type="checkbox" id="hrv" 
        [(ngModel)]="selectedMetrics['hrv']" (change)="onMetricToggle('hrv')"> HRV</label>
  </div>
</div>

<div style="width: 90%; position: relative; min-height: 300px;" *ngIf="showChart">
  <highcharts-chart #chart [Highcharts]="Highcharts" [options]="chartOptions" [(update)]="updateFlag"
    [oneToOne]="oneToOneFlag" [runOutsideAngular]="runOutsideAngular"
    style="width: 100%; height: 100%; display: block;"></highcharts-chart>
  <div *ngIf="noDataFound"
    style="position: absolute; top: 50%; left: 0; width: 100%; text-align: center; transform: translateY(-50%); pointer-events: none;">
    <h6 style="color: gray;">{{ emptyMessage }}</h6>
  </div>
</div>

<!-- Navigation hint -->
<div class="row mt-2" *ngIf="showChart && !noDataFound">
  <div class="col-md-12">
    <div class="navigation-hint">
      <small style="color: #666;">
        <strong>Navigation:</strong> Drag to zoom in • Hold <strong>Shift</strong> and drag to pan left/right • Click "Reset zoom" to view all data
      </small>
    </div>
  </div>
</div>

<!-- Timeline Modal -->
<div class="modal fade" id="metricsTimelineModal" tabindex="-1" role="dialog" aria-labelledby="metricsTimelineModalTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content gmodalcontent">
      <div class="modal-header modal-header-row">
        <div class="modal-title-section">
          <img [src]="modalImg" class="modal-icon">
          <h5 class="modal-title mtitle" id="metricsTimelineModalTitle">{{modalType}}</h5>
        </div>
        <div class="modal-time-close">
          <span *ngIf="modalType === 'Sleep'" class="modal-time">{{modalSTime}} - {{modalETime}}</span>
          <span *ngIf="modalType === 'Activity'" class="modal-time">{{modalSTime}} - {{modalETime}}</span>
          <span *ngIf="modalType !== 'Sleep' && modalType !== 'Activity'" class="modal-time">{{modalSTime}}</span>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
      <div class="modal-body">
        <div class="row smtitle" *ngIf="modalType == 'Sleep'">
          Total Sleep Duration
        </div>
        <div class="row smbody" *ngIf="modalType == 'Sleep'">
          {{modalDuration}}
        </div>
        <div class="row smtitle" *ngIf="modalType == 'Activity'">
          <div class="col-md-4">
            Activity Name
          </div>
          <div class="col-md-4">
            Calories Burned
          </div>
          <div class="col-md-4">
            Distance Covered
          </div>
        </div>
        <div class="row smbody" *ngIf="modalType == 'Activity'">
          <div class="col-md-4">
            {{activityName}}
          </div>
          <div class="col-md-4">
            {{calsBurned}} kcal
          </div>
          <div class="col-md-4">
            {{distCovered}} {{distUnits}}
          </div>
        </div>
      </div>
      <br />
      <br />
    </div>
  </div>
</div>
